import { css } from '@emotion/react';
import styled from '@emotion/styled';
import SkeletonRect from '../skeleton/SkeletonRect';
import Image from '../ImageNext';

const SkeletonFlag = styled(SkeletonRect)`
  height: 19px;
`;

const Flag = ({ currencyCode = 'usd', size = 'large', showSkeleton = false } = {}) => {
  return (
    <span
      css={css`
        display: flex;
        align-items: center;
        width: ${size === 'large' ? 40 : 28}px;
      `}
    >
      {showSkeleton ? (
        <SkeletonFlag />
      ) : (
        <Image
          src={`/images/flags/currency/${currencyCode.toLowerCase()}.png`}
          alt={currencyCode.toUpperCase()}
          width={48}
          height={32}
          css={css`
            width: 100%;
            height: auto;
          `}
        />
      )}
    </span>
  );
};

export default Flag;
